__turbopack_context__.v({
  "btn": "NewsletterForm-module-scss-module__6c-tQa__btn",
  "btnWrapper": "NewsletterForm-module-scss-module__6c-tQa__btnWrapper",
  "form": "NewsletterForm-module-scss-module__6c-tQa__form",
  "successMsg": "NewsletterForm-module-scss-module__6c-tQa__successMsg",
});
